import React, { useEffect } from "react";
import { View } from "react-native";
import {
  Heading,
  Panel,
  theme,
  useModal,
  useResponsive,
} from "@clearabee/ui-library-native";
import { Button } from "components/Core/Button/Button";
import { styles, ids } from "./LoginBanner.styles";
import { Coins } from "components/Core/Vector/Coins";
import { LoginForm } from "components/LoginForm/LoginForm";
import { useTranslation } from "react-i18next";
import { useAuth } from "lib/hooks/useAuth";

export const LoginBanner = (): React.ReactElement => {
  const [translate] = useTranslation();
  const [LoginModal, showLoginModal] = useModal();
  const { user } = useAuth();
  const { screens } = useResponsive();

  useEffect(() => {
    if (user) {
      showLoginModal(false);
    }
  }, [user]);

  return (
    <>
      <Panel
        styles={styles.panel}
        color="warning"
        shadow
        dataSet={{ media: ids.panel }}
      >
        <View
          style={styles.wrap}
          dataSet={{
            media: ids.wrap,
          }}
        >
          <View style={styles.coins} dataSet={{ media: ids.coins }}>
            <Coins width={31} height={50} />
          </View>
          <Heading
            level={screens.medium ? 4 : 6}
            color="greyscale.base"
            styles={{
              position: "relative",
              marginLeft: theme.spacing.small,
              fontFamily: "ProximaBold",
            }}
          >
            {translate("hwa.screens.productDetails.haveAnAccount")}
          </Heading>
          {screens.medium && (
            <Heading
              level={6}
              color="greyscale.base"
              styles={{
                position: "relative",
                marginLeft: theme.spacing.small,
              }}
            >
              {translate("hwa.screens.productDetails.loginPrompt")}
            </Heading>
          )}
          <View style={styles.button} dataSet={{ media: ids.button }}>
            <Button
              size="small"
              onClick={() => showLoginModal(true)}
              color="greyscale"
              variant="outline"
              type="button"
              styles={{
                margin: "auto",
              }}
            >
              {translate("hwa.screens.login.title")}
            </Button>
          </View>
        </View>
      </Panel>
      <LoginModal
        color="brand"
        width={550}
        onClose={() => showLoginModal(false)}
      >
        <LoginForm />
      </LoginModal>
    </>
  );
};
